import { Col, Modal, Button, Row, ModalFooter } from "react-bootstrap";
import React from "react";

const BillDetailsPopup = (props) => {
  console.log("popupData", props.popupData);
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="common-modal"
    >
      <Modal.Header>
        <Modal.Title>
          <h1>{props.title}</h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {props.popupData &&
          props.popupData.map((data) => (
            <Row className="modal-body-content" style={{ padding: "5px 0px" }}>
              <Col
                lg="5"
                className="label-bank-details"
                style={{ paddingLeft: "0px" }}
              >
                {data && data.label}
              </Col>
              <Col lg="1" style={{ paddingLeft: "0px" }}>
                :
              </Col>
              <Col
                lg="6"
                style={{
                  textAlign: "left",
                  paddingRight: "0px",
                  paddingLeft: "0px",
                }}
              >
                {" "}
                {data && data.value}
              </Col>
            </Row>
          ))}
      </Modal.Body>
      <ModalFooter style={{ width: "100%", justifyContent: "center" }}>
        <Button color="primary" onClick={props.close}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default BillDetailsPopup;
